// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*{padding:0;margin:0;box-sizing:border-box;font-family:'Lato', sans-serif}\n", "",{"version":3,"sources":["webpack://./src/styles/main.scss"],"names":[],"mappings":"AAAA,EAAI,SAAU,CAAE,QAAS,CAAE,qBAAsB,CAAE,8BAA+B","sourcesContent":["* { padding: 0; margin: 0; box-sizing: border-box; font-family: 'Lato', sans-serif;}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
